module.exports = __webpack_public_path__ + "img/missed_notification_white.90676145.svg";